import * as $ from "jquery";
import * as Swiper from 'swiper/dist/js/swiper.min';

function CollectionCarousel() {
	$('.js-collection-carousel').each(function(index, element) {
		let $this = $(this);
		$this.addClass('collection-carousel-'+index);
		let $parent = $this.parents('.collection-carousel__container');
		let carouselList = [];

		//setup each swiper instances
		let cCarousel = new Swiper('.collection-carousel-'+index, {
			slidesPerView: 4,
			slidesPerGroup: 4,
			speed: 400,
			spaceBetween: 6,
			centeredSlides: false,
			loop: false,
			simulateTouch: true,
			watchOverflow: true,

			breakpoints: {
				// when window width is <= 640
				640: {
					slidesPerView: 1,
					slidesPerGroup: 1
				},
				991: {
					slidesPerView: 2,
					slidesPerGroup: 2
				},
				1199: {
					slidesPerView: 3,
					slidesPerGroup: 3
				}
			},

			pagination: {
				el: $parent.find('.swiper-pagination'),
				type: 'bullets',
				clickable: true
			},

			// Navigation arrows
			navigation: {
				nextEl: $parent.find('.swiper-button-next'),
				prevEl: $parent.find('.swiper-button-prev')
			}
		});

		carouselList.push(cCarousel);
		cCarousel.init();
	});
}

export function init() {
	CollectionCarousel();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/collectionCarousel.ts